import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  ConfirmationService,
  ConfirmEventType,
  MessageService,
} from 'primeng/api';
import { Table } from 'primeng/table';
import { CommonClass } from 'src/app/common';
import { ApiService } from 'src/app/services/api.service';
import { InterestMasterService } from 'src/app/services/interest-master.service';
import { NatureOfBusinessMasterService } from 'src/app/services/nature-of-business-master.service';
import { PaymentService } from 'src/app/services/payment.service';
import { utility } from 'src/app/services/utility';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-terminate-list',
  templateUrl: './terminate-list.component.html',
  styleUrls: ['./terminate-list.component.scss']
})
export class TerminateListComponent implements OnInit {
 @ViewChild('nameFilter') dataTable: Table;
  @ViewChild('hwmverification') hwmverification: NgForm;
  baseUrl = environment.regularMemberListURL;
  ucciBaseUrl = environment.ucci_base_url;
  loading: boolean = false;
  hwmMemberList: any = [];
  inprogress: string = 'In Progress';
  breadcrumb: any[];
  isShow: boolean = false;
  displayMaximizable: boolean = false;
  localStorage: any;
  email: any = '';
  company_name: any = '';
  filterVal: string;
  tooltipText: string = environment.resetTooltip;
  dtDataLength: any;
  hwmDetails: any = [];
  trustArray: any = [];
  addArray: any = [];
  HWMDetailsId: any = [];
  consent_status: any = [];
  waste_details: any = [];
  product_details: any = [];
  cols: { field: string; header: string }[];
  exportColumns: { title: string; dataKey: string }[];
  pdfData: any[];
  multipleFields: any = [{ key: null, value: null, dropdownKey: [] }];
  objectKeysArray: any = [];
  selectedMember:any
  @Input() hideDataForAnotherComponent: boolean = true;
TerminationDialog:boolean=false;
terminationremark:string
verificationdetail:string

// In your class, define an array to store filter values
filterValues: any = [];


  keyNames: any = ['turn_over', 'Nature of Business'];
  colFilter = [
    { field: 'S. No.' },
    { field: 'action' },
    { field: 'payment' },
    { field: 'status' },
    { field: 'company_name' },
    { field: 'member_since'},
    { field: 'membership_no' },
    { field: 'email' },
    { field: 'date' },
    { field: 'renewal_status' },
    { field: 'invoice' },
    { field: 'checklist' },
    { field: 'letter' },
    { field: 'notesheet' },
  ];

  status = [
    { label: 'Verified', value: 'Verified' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Approved', value: 'approved' },
    { label: 'In Progress', value: 'in progress' },
    { label: 'Terminated', value: 'Terminated' },
    { label: 'Provisionally Terminated', value: 'Provisionally Terminated' },
  ];
  renewal_status = [
    { label: 'Pending', value: 'pending' },
    { label: 'Renewed', value: 'renewed' },
  ];
  excelData: any[];
  filteredXLSData: any[];
  filteredPDFData: any[];
  turnOverData: any = [];
  areaOfInterest: any = [];
  natureofBusinessListData: any = [];
  roleObject: any = environment.roles;
  total: any = 0;
  AdmissionFeeTotal: number = 0;
  TrustFeeTotal: number = 0;
  payStatus: boolean = false;
  slug: any;
  successState: boolean;
  message: any;
  paymentResponse: { formState: boolean; merchantRequest: string, string: any };
  rowId: any;
  paymentFor: any;
  userPermission: any;
  updatePermission: boolean = false;
  deletePermission: boolean = false;
  viewPermission: boolean = false;
  approvalPermission: boolean = false
  paymentDialog: boolean = false;
  showHwmListing: boolean = true;
  showRenewalListing: boolean = true;
  memberVerficationDetails:any
  paymentMode: any = [
    { label: 'Cash', value: 'Cash' },
    { label: 'Cheque', value: 'Cheque' },
    { label: 'RTGS', value: 'RTGS' },
    { label: 'NEFT', value: 'NEFT' },
    { label: 'IMPS', value: 'IMPS' },
    { label: 'Payment Gateway', value: 'Payment Gateway' },
  ];
  renewalListing: any = [];
  VerificationDialog: boolean = false;
  pollutionLetterDialog: boolean = false;
  draftData: any = [];
  response: any = [];
  storageData: any;
  HwmDetailsId: any;
  userVerified: any;
  verficationStatus: any;
  userNames: string[] = [];
  enableAddButton: boolean=false;
  constructor(
    private commonFunction: CommonClass,
    private __apiservice: ApiService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private paymentservice: PaymentService,
    public apiService: ApiService,
    private spinner: NgxSpinnerService,
    public interestMasterService: InterestMasterService,
    private natureofBusiness: NatureOfBusinessMasterService,
    private activated: ActivatedRoute,
    private router: Router,
    private utility: utility,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.localStorage = this.commonFunction.getLocalStorage();
    this.storageData = JSON.parse(localStorage.getItem('access_token'));
    this.spinner.show();
    this.slug = this.activated.snapshot.params;
  
    this.getTerminateMember();
   
    if ((this.localStorage.role == 'Admin') || (this.localStorage.role == 'UCCI Staff') || (this.localStorage.role == 'President')) {
      this.colFilter = [
        { field: 'S. No.' },
        { field: 'action' },
        {field:'status'},
        { field: 'company_name' },
        { field: 'email' },
      ];

    }
  }

 getTerminateMember(){
  const id = 2
  this.apiService.terminateHWM(id).subscribe(
    (res:any) =>{
      this.response=res.data;
      this.verificationdetail=this.response.terminate_verification
      console.log(this.verificationdetail);
      
      console.log(this.response);
    }
  )
 }
approveMemberById(id?: any, status?: any){
console.log(id,status);
}
reset(dt){
  this.filterVal=''
  dt.Clear()
}
 terminationstring:any
  selectedMemberId: any;
  terminatted(member_id?: any, value?: any, string?:any, memberdetail?: any) {
      console.log(this.terminationstring);
       this.selectedMember = memberdetail;
       console.log(this.selectedMember);
       
      this.selectedMemberId= member_id
     const userid =this.localStorage.userId
        this.TerminationDialog=true
       console.log(userid);
        console.log(value);
      let status = '';
   

}
verificationFormFunction() {
  const userid = this.localStorage.userId;
  const remark = this.verificationForm.value.remark;
  const verification = this.selectedMember.terminate_verification;

  // Determine which slot to fill (1 → 2 → 3)
  let payload: any = {
    member_id: this.selectedMemberId,
    status: 'partially terminated',
  };

  if (!verification.tvid_1) {
    payload.tvid_1 = userid;
    payload.tvremarks_1 = remark;
    payload.tverification1 = 1;
  } else if (!verification.tvid_2) {
    payload.tvid_2 = userid;
    payload.tvremarks_2 = remark;
    payload.tverification2 = 1;
  } else if (!verification.tvid_3) {
    payload.tvid_3 = userid;
    payload.tvremarks_3 = remark;
    payload.tverification3 = 1;
  } else {
    this.messageService.add({
      severity: 'warn',
      detail: 'All verification slots are already filled.',
    });
    return;
  }

 
  this.apiService.terminatedHwm(payload).subscribe(
    (res: any) => {
      this.messageService.add({
        severity: 'success',
        detail: res?.message || 'Status updated successfully.',
      });
      this.TerminationDialog = false; 
    },
    (error) => {
      this.messageService.add({
        severity: 'error',
        detail: error.message || 'Error updating status.',
      });
    }
  );
}

finalTerminate(id: any, value: any) {
  this.confirmationService.confirm({
    message: 'Are you sure that you want to Terminate?',
    header: 'Confirmation',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      console.log(id);

      this.apiService.finalterminate(id).subscribe(
        (res: any) => {
          this.getTerminateMember();
          this.messageService.add({
            severity: 'success',
            detail: res?.message || 'Status updated successfully.',
          });
        },
        error => {
          this.messageService.add({
            severity: 'error',
            detail: error.message || 'Error updating status.',
          });
        }
      );
      this.TerminationDialog = false;
    },
    reject: () => {
        this.messageService.add({
            severity: 'info',
            detail:'Cancelled',
          });
           }
  });
}
  verificationForm = new FormGroup({ remark: new FormControl('', [Validators.required]) });
}
